import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import Text from 'components/common/Text'
import { Color } from 'constants/color'
import { _studentsCount } from 'store/selectors/Room'

import { submitChoice } from './helpers'
import * as Styles from './styles'

import Choice from '../../Choice'
import { renderUsers } from '../../helpers'
import { QuizChoiceButton } from '../../MotionButton'

const Choices = ({ choices, isTimerOver, isTeacher, quesUuid }) => {
    const studentsCount = useSelector(_studentsCount)

    /* select choice local state for student */
    const [selectedChoice, setSelectedChoice] = useState() // choice uuid
    const selectChoice = choiceUuid => {
        if (selectedChoice === choiceUuid) return
        setSelectedChoice(choiceUuid)
        submitChoice({ choiceUuid, quesUuid })
    }

    if (!choices) return null

    return (
        <Styles.Options>
            {Object.values(choices)?.map(
                ({ uuid, choice, is_answer, users }, index) => {
                    const isSelected = selectedChoice === uuid
                    return (
                        <Styles.ChoiceFlexContainer key={uuid}>
                            {isTeacher || isTimerOver ? (
                                <Choice
                                    option={index}
                                    isCorrect={is_answer}
                                    numParticipantsSelected={users.length}
                                    totalParticipants={studentsCount}
                                    content={choice}
                                    isSelected={isSelected}
                                />
                            ) : (
                                <QuizChoiceButton
                                    option={index}
                                    content={choice}
                                    isSelected={isSelected}
                                    onClick={() => selectChoice(uuid)}
                                />
                            )}
                            {isTeacher ? (
                                <Styles.TextContainer>
                                    <Text
                                        color={Color.black}
                                        bold={false}
                                        level="2"
                                    >
                                        {renderUsers(users)}
                                    </Text>
                                </Styles.TextContainer>
                            ) : null}
                        </Styles.ChoiceFlexContainer>
                    )
                }
            )}
        </Styles.Options>
    )
}

export default Choices
